export function renderEthos() {
  return `
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 pb-14 sm:pb-16 border-b border-[#1C201E] font-mono">
      <div class="border-l border-[#2E3330] pl-5 space-y-1.5 group hover:border-ember transition-colors">
        <span class="text-neutral-500 text-xs uppercase tracking-widest block font-medium">01 / THINK</span>
        <span class="text-lg font-bold text-stark tracking-tight block">Understand the problem.</span>
        <p class="text-xs text-neutral-400 mt-1 leading-relaxed">First-principles analysis before writing a line of code.</p>
      </div>
      <div class="border-l border-[#2E3330] pl-5 space-y-1.5 group hover:border-ember transition-colors">
        <span class="text-neutral-500 text-xs uppercase tracking-widest block font-medium">02 / BUILD</span>
        <span class="text-lg font-bold text-stark tracking-tight block">Turn the idea into a system.</span>
        <p class="text-xs text-neutral-400 mt-1 leading-relaxed">High craftsmanship, deterministic logic, expressive interfaces.</p>
      </div>
      <div class="border-l border-[#2E3330] pl-5 space-y-1.5 group hover:border-ember transition-colors">
        <span class="text-neutral-500 text-xs uppercase tracking-widest block font-medium">03 / BREAK</span>
        <span class="text-lg font-bold text-stark tracking-tight block">Find what doesn't work.</span>
        <p class="text-xs text-neutral-400 mt-1 leading-relaxed">Stress-testing assumptions, edge cases, and mechanical limits.</p>
      </div>
      <div class="border-l border-[#2E3330] pl-5 space-y-1.5 group hover:border-ember transition-colors">
        <span class="text-neutral-500 text-xs uppercase tracking-widest block font-medium">04 / SHIP</span>
        <span class="text-lg font-bold text-stark tracking-tight block">Make it real.</span>
        <p class="text-xs text-neutral-400 mt-1 leading-relaxed">Deploying resilient solutions into the world with pride.</p>
      </div>
    </div>
  `;
}
